import { render, staticRenderFns } from "./header-8coin.vue?vue&type=template&id=233e9140&"
import script from "./header-8coin.vue?vue&type=script&lang=js&"
export * from "./header-8coin.vue?vue&type=script&lang=js&"
import style0 from "./header-8coin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header-8coin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports